import { render, staticRenderFns } from "./ButtonMore.vue?vue&type=template&id=2c76b47c"
import script from "./ButtonMore.vue?vue&type=script&lang=js"
export * from "./ButtonMore.vue?vue&type=script&lang=js"
import style0 from "./ButtonMore.vue?vue&type=style&index=0&id=2c76b47c&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c76b47c')) {
      api.createRecord('2c76b47c', component.options)
    } else {
      api.reload('2c76b47c', component.options)
    }
    module.hot.accept("./ButtonMore.vue?vue&type=template&id=2c76b47c", function () {
      api.rerender('2c76b47c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/ButtonMore.vue"
export default component.exports